import {
    createContext, Dispatch, SetStateAction, Key,
} from 'react';

export interface ISettingProgramContextArgs {
    entityName: string;
    selectedTabKey: Key | null;
    setSelectedTabKey: Dispatch<SetStateAction<Key>> | null;
}

export const SettingProgramContext = createContext<ISettingProgramContextArgs>({
    entityName: '',
    selectedTabKey: null,
    setSelectedTabKey: null,
});
